"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ProviderMicrodata = ({ provider }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("meta", { itemProp: "publicAccess", content: "true" }),
        react_1.default.createElement("meta", { itemProp: "isAcceptingNewPatients", content: provider.accepting_new_patients ? 'true' : 'false' }),
        provider.insurance_accepted.map((insuranceName, index) => (react_1.default.createElement("meta", { itemProp: "healthPlanNetworkId", content: insuranceName, key: insuranceName + index }))),
        provider.age_groups_seen.map((age_group, index) => (react_1.default.createElement("meta", { itemProp: "medicalSpecialty", content: age_group, key: age_group + index }))),
        provider.languages.map((language, index) => (react_1.default.createElement("meta", { itemProp: "knowsLanguage", content: language, key: language + index })))));
};
exports.default = ProviderMicrodata;
//# sourceMappingURL=provider-microdata.js.map